module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage1-desktop.jpg?v=1d3fc9c6";